// @flow
import PlainEditableProp, { type EditablePropProps } from './plain-editable-prop';


export default PlainEditableProp;
export type { EditablePropProps };
